<template>
  <card shadow style="padding-top: 0.5rem !important; padding-bottom: 0.5rem !important">
    <div :class="isMobile ? 'flex' : 'block mb-2'">
      <img :src="img" class="mb-2 md:h-20 h-12 md:mr-2"  />
      <h6 class="font-bold md:text-md text-sm" :class="isMobile ? 'pt-2' : ''">Kalkulator Harga</h6>
    </div>
    <p class=" md:text-sm text-xs pb-3 md:pb-0">Cek Estimasi Ongkir Pengirimanmu</p>
    <router-link to="/costcalculator">
      <b-button type="is-warning-gradient">CEK</b-button>
    </router-link>
  </card>
</template>

<script>
import img from '@/assets/ipost/calc.png'
import Card from './Card'
export default {
  components: {
    Card
  },
  data () {
    return {
      img
    }
  }
}
</script>

<style>

</style>
